import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../classes/styles/style.css';
import { GetGlobalContext, GlobalContextData } from '../classes/context';
import * as WS from "../webServices/cyMyManager"

export default function Login() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);

    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rico, setRico] = useState(false);

    const signIn = async (usr: string, psw: string, ric: boolean,) => {
        const res = await WS.Plus.loginEsercente(WS.UT.TOKEN, usr, psw)

        if (res.isOk === false || (res.data?.Id ?? 0) === 0) {
            alert('Login Fallito')
            return
        }

        if (ric === false) {
            localStorage.removeItem('ric');
        } else {
            localStorage.setItem('ric', JSON.stringify({ username: usr, password: psw }))
        }

        globalContext.update({ ...globalContext.vars, esercente: res.data });
        navigate('/home/');
    }

    useEffect(() => {
        let item = localStorage.getItem("ric");
        let login = undefined;
        if (item !== null) 
            login = JSON.parse(item);
        
        if (login)
            signIn(login.username, login.password, true);
    }, []);

    return (
        <div className='wrapper-login'>
            <div className='login-form'>
                <div className='login-body'>
                    <div className='login-head'>
                        <div className='login-img mb-4'>
                            <img src="/assets/img/logo/AYCW_LOGO.png" alt="" />
                        </div>
                        <h4>Accedi</h4>
                    </div>
                    <div className='row mt-3'>
                        <div className='form-group col-12'>
                            <label htmlFor="username">Username</label>
                            <input type="text" name='username' className='form-control' value={username} onChange={username => setUsername(username.target.value)} />
                        </div>
                        <div className='form-group col-12'>
                            <label htmlFor="password">Password</label>
                            <input type="password" name='password' className='form-control' value={password} onChange={password => setPassword(password.target.value)} />
                        </div>
                        <div className='form-group col-12  mt-3'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" checked={rico} onChange={rico => setRico(rico.target.checked)} />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Ricordami
                                </label>
                            </div>
                        </div>
                        <div className='col-12 d-flex mt-5'>
                            <button className='btn btn-custom w-100' onClick={() => signIn(username, password, rico)}>Accedi</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='login-info'>
                <div className='login-info-img'>
                    <img src="/assets/img/logo/AYCW_LOGO.png" alt="" />
                </div>
            </div>
        </div>
    );
}

